/**
 * Map DailySummary v2 payloads to legacy dashboard shapes.
 */

export function summaryToMetrics(summary) {
  if (!summary) return null;
  if (summary.legacy?.metrics) return summary.legacy.metrics;
  return {
    dayKey: summary.dayKey,
    date: summary.date,
    habits: {
      steps: summary.importedMetrics?.steps ?? summary.manualMetrics?.steps ?? 0,
      waterIntake: summary.importedMetrics?.waterIntake ?? summary.manualMetrics?.waterIntake ?? 0,
      exerciseHours: summary.importedMetrics?.exerciseHours ?? summary.manualMetrics?.exerciseHours ?? 0,
      // Do not fabricate a goal here: an absent value must stay absent so
      // resolveGoals() (habits -> preferences -> canonical default) is the
      // single place that decides what "no goal set" resolves to. A
      // plausible-looking literal here is indistinguishable downstream from
      // a value the user actually chose.
      waterGoal: summary.manualMetrics?.waterGoal,
      stepsGoal: summary.manualMetrics?.stepsGoal,
      exerciseGoal: summary.manualMetrics?.exerciseGoal,
      lastUpdated: summary.manualMetrics?.lastUpdated,
    },
    fasting: summary.fasting || null,
    food: {
      foodEntries: summary.nutrition?.foodEntries || [],
      customCalorieLimit: summary.nutrition?.customCalorieLimit ?? null,
      lastUpdated: summary.nutrition?.lastUpdated,
    },
    lastUpdated: summary.lastUpdated,
  };
}

export function summaryToHealth(summary) {
  if (!summary) return null;
  if (summary.legacy?.health) return summary.legacy.health;
  return {
    dayKey: summary.dayKey,
    date: summary.date,
    steps: summary.importedMetrics?.steps ?? summary.manualMetrics?.steps ?? 0,
    waterIntake: summary.importedMetrics?.waterIntake ?? summary.manualMetrics?.waterIntake ?? 0,
    exerciseHours: summary.importedMetrics?.exerciseHours ?? summary.manualMetrics?.exerciseHours ?? 0,
    activeCaloriesBurned: summary.importedMetrics?.caloriesBurned ?? 0,
    heartRate: summary.importedMetrics?.heartRate ?? summary.bodyMetrics?.restingHeartRate ?? null,
    restingHeartRate: summary.bodyMetrics?.restingHeartRate ?? null,
    hrv: summary.bodyMetrics?.hrv ?? summary.importedMetrics?.hrv ?? null,
    sleepMinutes: summary.importedMetrics?.sleepMinutes ?? summary.wellbeing?.sleepDuration ?? null,
    bloodGlucose: summary.bodyMetrics?.bloodGlucose ?? null,
    bloodOxygen: summary.bodyMetrics?.bloodOxygen ?? null,
    bloodPressure: summary.bodyMetrics?.bloodPressure ?? null,
    lastUpdated: summary.lastUpdated,
  };
}

export function summaryToReflection(summary) {
  const wellbeing = summary?.wellbeing || {};
  return {
    notes: wellbeing.notes || '',
    energy: wellbeing.energy ?? 4,
    mood: wellbeing.mood ?? 4,
    gratitude: wellbeing.gratitude || '',
  };
}

export function summariesToMetricsRange(summaries = []) {
  return summaries.map(summaryToMetrics).filter(Boolean);
}

export function summariesToHealthRange(summaries = []) {
  return summaries.map(summaryToHealth).filter(Boolean);
}
